// ----------------------------------------------------------------------
// <copyright file="Izenda.PermissionExporting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Input = require('share/components/controls/Izenda.Input');
  var actions = require('../Izenda.PermissionActions');
  var SECTION = require('logic/data/Izenda.PermissionConstants').SECTION;
  var EventsUtils = require('EventUtils');
  var LicenseCheckerConstants = require('logic/data/Izenda.LicenseCheckerConstants');
  var CheckboxAllPermission = require('./Izenda.CheckboxAllPermission');
  const { isNil, get } = require('lodash/fp');

  var PermissionEmailing = React.createClass({
    propTypes: {
      permission: React.PropTypes.object.isRequired
    },

    componentWillMount: function() {
      this.exporting = this.props.permission.exporting;
    },

    render: function() {
      var notifyChange = EventsUtils.notifyChange;
      var permissionStore = this.props.permissionStore;
      var permission = this.props.permission;
      var tenantDetail = permissionStore.tenantDetail;
      var localization = this.props.localization;
      var authorization = this.props.authorization;
      var isTemplatePermissions = this.props.isTemplatePermissions;
      var hasExportLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Exporting);
      var hasIframeLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.Iframe);
      var exporting = get('exporting', tenantDetail);

      var isVisible = hasExportLicense &&
        !permission.fullReportAndDashboardAccess &&
        (isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.exporting));

      return (
        isVisible && (
          <div className={SECTION.Exporting}>
            <GridLayout className='izenda-GridLayout-Custom'>
              <GridLayout.Row className='u_textBold u_paddingTop u_paddingBottom izenda-PermissionCategory-Header'>
                <GridLayout.Col cols={2}>
                  <a
                    className={this.props.getIconClass('isShowExporting')}
                    onClick={this.props.toggle.bind(this, 'isShowExporting')}
                  />
                  {localization.getText('COMMON_LABEL_EXPORTING')}
                </GridLayout.Col>
                <GridLayout.Col cols={9}>
                  <CheckboxAllPermission
                    permission={permission}
                    readOnly={this.props.readOnly}
                    disabled={isTemplatePermissions}
                    section={this.exporting}
                    tenantPermission={exporting}
                    tenantDetail={tenantDetail}
                  />
                </GridLayout.Col>
                {permission.isTenantSetup && (
                  <GridLayout.Col cols={1} className='u_textCenter'>
                    <Input
                      type='checkbox'
                      readOnly={this.props.readOnly}
                      disabled={isTemplatePermissions}
                      indeterminate={this.props.getIndeterminateCommon(this.exporting)}
                      checked={this.props.getCheckedCommon(this.exporting.tenantAccess)}
                      onChange={notifyChange(
                        permission.updateTenantAccessParent.bind(permission, this.exporting),
                        EventsUtils.CHECKBOX
                      )}
                    />
                  </GridLayout.Col>
                )}
              </GridLayout.Row>
            </GridLayout>
            {permissionStore.isShowExporting && (
              <GridLayout className='izenda-GridLayout-Custom'>
                {(isNil(tenantDetail) || this.props.checkShowGroupCommon(tenantDetail.exporting.exportingFormat)) && (
                  <GridLayout.Row className='u_paddingTop u_paddingBottom'>
                    <GridLayout.Col cols={2} className='izenda-PermissionCategory-SubCategory'>
                      {localization.getText('PERMISSION_LABEL_EXPORTING_FORMAT')}
                    </GridLayout.Col>
                    <GridLayout.Col cols={9}>
                      {(isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.word) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.word)}
                              onChange={notifyChange(
                                permission.updateData.bind(permission, this.exporting.exportingFormat, 'word'),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>Word</span>
                          </label>
                        </div>
                      )}
                      {(isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.excel) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.excel)}
                              onChange={notifyChange(
                                permission.updateData.bind(permission, this.exporting.exportingFormat, 'excel'),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>Excel</span>
                          </label>
                        </div>
                      )}
                      {(isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.pdf) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.pdf)}
                              onChange={notifyChange(
                                permission.updateData.bind(permission, this.exporting.exportingFormat, 'pdf'),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>PDF</span>
                          </label>
                        </div>
                      )}
                      {(isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.csv) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.csv)}
                              onChange={notifyChange(
                                permission.updateData.bind(permission, this.exporting.exportingFormat, 'csv'),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>CSV</span>
                          </label>
                        </div>
                      )}
                      {(isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.xml) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.xml)}
                              onChange={notifyChange(
                                permission.updateData.bind(permission, this.exporting.exportingFormat, 'xml'),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>XML</span>
                          </label>
                        </div>
                      )}
                      {(isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.json) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.json)}
                              onChange={notifyChange(
                                permission.updateData.bind(permission, this.exporting.exportingFormat, 'json'),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>JSON</span>
                          </label>
                        </div>
                      )}
                      {(isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.queryExecution) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.queryExecution)}
                              onChange={notifyChange(
                                permission.updateData.bind(
                                  permission,
                                  this.exporting.exportingFormat,
                                  'queryExecution'
                                ),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>{localization.getText('PERMISSION_LABEL_QUERY_EXECUTION')}</span>
                          </label>
                        </div>
                      )}
                      {(isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.definition) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.definition)}
                              onChange={notifyChange(
                                permission.updateData.bind(permission, this.exporting.exportingFormat, 'definition'),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>{localization.getText('PERMISSION_LABEL_DEFINITION')}</span>
                            <span
                              className='icon-info-circled'
                              title={localization.getText('TENANT_TOOLTIP_DEFINITION_TYPE')}
                            />
                          </label>
                        </div>
                      )}
                      {hasIframeLicense && (isNil(tenantDetail) || tenantDetail.exporting.exportingFormat.iframe) && (
                        <div className='u_inlineBlock izenda-PermissionCategory-group_left'>
                          <label>
                            <Input
                              type='checkbox'
                              readOnly={this.props.readOnly}
                              disabled={isTemplatePermissions}
                              checked={this.props.getCheckedCommon(this.exporting.exportingFormat.iframe)}
                              onChange={notifyChange(
                                permission.updateData.bind(permission, this.exporting.exportingFormat, 'iframe'),
                                EventsUtils.CHECKBOX
                              )}
                            />
                            <span>{localization.getText('PERMISSION_LABEL_IFRAME')}</span>
                            <span className='icon-info-circled' title={localization.getText('TENANT_TOOLTIP_IFRAME')} />
                          </label>
                        </div>
                      )}
                    </GridLayout.Col>
                    {permission.isTenantSetup && (
                      <GridLayout.Col cols={1} className='u_textCenter'>
                        <Input
                          type='checkbox'
                          readOnly={this.props.readOnly}
                          disabled={isTemplatePermissions}
                          checked={this.props.getCheckedCommon(this.exporting.exportingFormat.tenantAccess)}
                          onChange={notifyChange(
                            permission.updateTenantAccess.bind(
                              permission,
                              this.exporting,
                              this.exporting.exportingFormat
                            ),
                            EventsUtils.CHECKBOX
                          )}
                        />
                      </GridLayout.Col>
                    )}
                  </GridLayout.Row>
                )}
              </GridLayout>
            )}
          </div>
        )
      );
    }
  });

  module.exports = connect({ toClass: true }, actions)(PermissionEmailing);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/PermissionTab/PermissionBody/Izenda.PermissionExporting.jsx